/* eslint-disable */
export default {
  sureToDeleteVoiceMail: 'Voulez-vous vraiment supprimer ce message vocal?',
  sureToDeleteFax: 'Voulez-vous vraiment supprimer cette télécopie?',
  doNotAskAgain: 'Ne plus me demander',
} as const;

// @key: @#@"sureToDeleteVoiceMail"@#@ @source: @#@"Are you sure you want to delete this voicemail?"@#@
// @key: @#@"sureToDeleteFax"@#@ @source: @#@"Are you sure you want to delete this fax?"@#@
// @key: @#@"doNotAskAgain"@#@ @source: @#@"Don't ask me again"@#@
